var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "card" }, [
      _c("h2", { staticClass: "mb-0" }, [
        _vm._v("Você precisa de limpezas semanais ou quinzenais?")
      ]),
      _vm._v(" "),
      _c("p", [
        _vm._v(
          "Com as Assinaturas Donamaid você pode reservar seu profissional favorito para limpezas na sua casa ou empresa com a frequência e duração que você precisa."
        )
      ]),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "btn btn-pink",
          attrs: {
            href: "https://www.donamaid.com/assinatura",
            target: "_blank",
            rel: "noopener noreferrer"
          }
        },
        [_vm._v("saiba mais")]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2f09b77c", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2f09b77c","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/Subscriptions/NoSubscriptions.vue
// module id = null
// module chunks = 